import gsap from "gsap";
// import {MotionPathPlugin} from "gsap/MotionPathPlugin.js";
// gsap.registerPlugin(MotionPathPlugin);

export default class LetterFlockAnimations {

  constructor() {}

  doFlyOffAnimation(x, y) {

    let letters = document.querySelectorAll("#words span.anim");
    letters.forEach((letter, i) => {
      let tm = gsap.timeline();
      let bb = letter.parentNode.getBoundingClientRect();
      tm.to(letter, {
        x : window.innerWidth - bb.x,
        y : y - bb.y + ((Math.random() - .5) * 300),
        duration : 3,
        ease : "sine.inOut",
        delay : i * .1
      });
      tm.to(
          letter,
          {x : -bb.x - bb.width, y : (Math.random() - .5) * 300, duration : 0});
      tm.to(letter, {x : 0, y : 0, duration : 1});
    });
  }

  // doFloatAnimation(x, y) {
  //   let radians_to_degrees = function(
  //       radians) { return radians * (180 / Math.PI); };
  //   let degrees_to_radians = function(
  //       degrees) { return degrees * (Math.PI / 180); };
  //   console.log("doFloatAnimation");
  //   let letters = document.querySelectorAll("#words span.anim");
  //   let mom = document.querySelector("#words");
  //   let step = (Math.PI * 2) / letters.length;
  //   console.log("letters", letters.length, step);
  //   letters.forEach((letter, i) => {
  //     let tm = gsap.timeline();
  //     let bb = mom.getBoundingClientRect();
  //     let lbb = letter.getBoundingClientRect();
  //     let centerBB = {x : bb.x + bb.width / 2, y : bb.y + bb.height / 2};
  //     // let len = Math.sqrt((centerBB.x - lbb.x) * (centerBB.x - lbb.x) +
  //     //                     (centerBB.y - lbb.y) * (centerBB.y - lbb.y));
  //     // let dir = {
  //     //   x : (lbb.x - centerBB.x) / len,
  //     //   y : (lbb.y - centerBB.y) / len
  //     // };
  //
  //     // console.log("pos", pos);
  //     let angle = i * step;
  //     let pos = {x : 0, y : 0};
  //     pos.x = -(lbb.x - bb.x) + bb.width / 2;
  //     pos.y = -(lbb.y - bb.y) + bb.height / 2;
  //     let r = 100; //(i + 1) * 1; // 50 + Math.random() * 50;
  //     pos.x += r * Math.sin(angle);
  //     pos.y += r * Math.cos(angle);
  //
  //     console.log("pos", pos);
  //     tm.to(letter, {x : pos.x, y : pos.y, duration : 1, ease :
  //     "sine.inOut"});
  //     // tm.to(letter.parentNode,
  //     //       {rotation : 90, duration : 1, ease : "sine.inOut"});
  //     tm.to(letter, {rotation : 360 * 4, duration : 1, ease : "sine.inOut"},
  //           "<");
  //     //       "<");
  //     // tm.to(letter, {
  //     //   x : window.innerWidth - bb.x,
  //     //   y : y - bb.y + ((Math.random() - .5) * 300),
  //     //   duration : 3,
  //     //   ease : "sine.inOut",
  //     //   delay : i * .1
  //     // });
  //     // tm.to(
  //     //     letter,
  //     //     {x : -bb.x - bb.width, y : (Math.random() - .5) * 300, duration
  //     :
  //     //     0});
  //     // tm.to(letter, {x : 0, y : 0, duration : 1});
  //   });
  // }
}
